import { TAddEditHospitalResponse } from 'components/Forms/forms.addEditHospital.d'

export const initialHospitalData: TAddEditHospitalResponse = {
  uuid: '',
  name: '',
  website: '',
  phone_number: '',
  health_system_name: '',
  status: '',
  address: {
    state: '',
    street: '',
    zip_code: '',
    city: ''
  },
  departments: []
}

export const downloadQRCodeOptions = [
  {
    key: 'image',
    label: 'Export as an image'
  },
  {
    key: 'pdf',
    label: 'Export to PDF'
  }
]
